<div class="p-inputgroup search-bar-container" [class.empty]="controlValue.length === 0">
    <input
        type="text"
        pInputText
        [id]="id + '-input'"
        name="searchValue"
        aria-label="Search Input"
        tabindex="0"
        [placeholder]="searchPlaceholder | translate"
        [maxlength]="maxLength"
        [disabled]="disabled"
        [(ngModel)]="controlValue"
        [class.disabled]="disabled"
        (keydown.enter)="search()"
        (focus)="searchbarFocus = true"
        (blur)="searchbarFocus = false"
        (input)="searchWithDebounce()"
        (ngModelChange)="checkSearchInputValue()" />
    <button
        [class.searchbar-focus]="searchbarFocus"
        [id]="id + '-clear-icon'"
        type="button"
        pButton
        icon="fa-solid fa-xmark"
        class="p-button-text clear-button"
        aria-label="Clear Button"
        [tabindex]="controlValue.length === 0 || disabled ? -1 : 0"
        [class.hidden]="controlValue.length === 0"
        [class.disabled]="disabled"
        (click)="clear($event)"
        (keydown.enter)="clear($event)"></button>
    <button
        [id]="id + '-btn'"
        aria-label="Search Button"
        [disabled]="disabled"
        type="button"
        pButton
        icon="pi pi-search"
        class="search-button"
        [class.disabled]="disabled"
        [class.searchbar-focus]="searchbarFocus"
        (click)="search()"></button>
</div>
